import React from 'react'
import Alert from '@material-ui/lab/Alert'
import Collapse from '@material-ui/core/Collapse'
import { scrollToResults } from 'utils/utilities'

type InlineAlertProps = {
  severity?: 'success' | 'error' | 'warning' | 'info'
  message: string | React.ReactNode
  onClose?: () => void
  autoScrollToAlert?: boolean
  customClass?: string
}

export const InlineAlert: React.FC<InlineAlertProps> = ({
  severity = 'success',
  message,
  onClose,
  autoScrollToAlert = true,
  customClass = 'my-6 py-3 text-lg',
}) => {
  const [open, setOpen] = React.useState(false)
  const inlineAlertRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    setOpen(true)
    if (autoScrollToAlert) {
      scrollToResults(inlineAlertRef, {
        scrollPosition: 'center',
        ignoreInlineAlerts: true,
      })
    }
    if (severity === 'success') {
      setTimeout(() => {
        setOpen(false)
      }, 5000)
    }
    return () => {
      setOpen(false)
    }
  }, [autoScrollToAlert, severity])

  const getClassName = () => {
    if (autoScrollToAlert && open) return 'inline-alert'
    return ''
  }

  return (
    <Collapse ref={inlineAlertRef} className={getClassName()} in={open}>
      <Alert
        className={customClass}
        severity={severity}
        onClose={() => {
          setOpen(false)
          if (onClose) onClose()
        }}
      >
        {(severity === 'error' || severity === 'success') && (
          <span>{severity === 'error' ? 'Error! ' : 'Success! '}</span>
        )}
        <span className="font-light">{message}</span>
      </Alert>
    </Collapse>
  )
}
